var fn = function( obj ){
var __t,__p='';
__p+='uniform vec3 uContrastScale;\nuniform vec3 uContrastBias;';
return __p;
};
fn.toString=fn;
module.exports = fn;